import { defineStore } from "pinia";

type State = {
  savedScrollPosition: number;
  packageVersion: string;
};

export const useUiStore = defineStore("ui", {
  state: (): State => ({
    savedScrollPosition: 0,
    packageVersion: "",
  }),

  actions: {
    saveScrollPosition(position: number) {
      this.savedScrollPosition = position;
    },

    clearScrollPosition() {
      this.savedScrollPosition = 0;
    },

    setPackageVersion(version: string) {
      this.packageVersion = version;
    },
  },
});
